const apiV2Base = 'https://api.form-data.com/v2'
// const apiV2Base = 'https://staging-api.form-data.com/v2'

import {getIdToken} from './auth'
import isEqual from 'lodash.isequal'
import extend from "just-extend"

class Api {

  static async assignAppsumoLicense(licenseKey) {
    console.log('assignAppsumoLicense')
    const idToken = await getIdToken()
    const res =  await fetch(`${apiV2Base}/accounts/myAccount/appsumo/assign-license`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `IDTOKEN.${idToken}`
      },
      body: JSON.stringify({ licenseKey })
    })
    if (!res.ok) {
      console.error('Unable to assign license')
      return null
    }
    const json = await res.json()
    return json.account
  }

  static async upgradeAppsumoWorkspaces(workspaces) {
    console.log('upgradeAppsumoWorkspaces')
    const idToken = await getIdToken()
    const res =  await fetch(`${apiV2Base}/accounts/myAccount/appsumo/upgrade-workspaces`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `IDTOKEN.${idToken}`
      },
      body: JSON.stringify({ workspaces })
    })
    if (!res.ok) {
      console.error('Unable to upgrade appsumo workspaces')
      return false
    }
    return true
  }

  static async resetPassword (email) {
    console.log('resetPassword', email)
    return await fetch(`${apiV2Base}/reset-password`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        data: {
          email
        }
      })
    })
  }

  static async formAssistant(currentForm, prompt) {
    // const res = await fetch('http://localhost:8787/v2/assistant', {
    const res = await fetch(`${apiV2Base}/assistant`, {
      method: 'POST',
      body: JSON.stringify({
        currentForm, prompt
      })
    } )
    return (await res.json())
  }

  static async listSubmissions (workspaceId, formId, folder = 'inbox', pageSize = 25, from, to, nextPage, prevPage) {
    const idToken = await getIdToken()
    const query = {
      folder,
      limit: pageSize
    }
    if (from) {
      query.from = new Date(from).toISOString()
    }
    if (to) {
      query.to = new Date(to).toISOString()
    }
    if (nextPage) {
      query.nextPage = nextPage
    }
    if (prevPage) {
      query.prevPage = prevPage
    }
    const res = await fetch(`${apiV2Base}/workspaces/${workspaceId}/forms/${formId}/submissions?${new URLSearchParams(query)}`, {
      method: 'GET',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`
      }
    })
    if (res.status === 403) {
      throw {name: 'Unauthorized', message: 'Unauthorized'};
    }
    return (await res.json())
  }

  static async getAnalyticsToken(accountId, workspaceId) {
    if (!accountId && !workspaceId) {
      console.trace('Analytics token initialization without accountId or workspaceId')
      return
    }
    const idToken = await getIdToken()
    const uri = accountId ? `https://api.form-data.com/v2/accounts/${accountId}/analytics-token` : `https://api.form-data.com/v2/workspaces/${workspaceId}/analytics-token`
    const res = await fetch(uri, {
      method: 'GET',
      headers: {
        Authorization: `IDTOKEN.${idToken}`
      }
    })
    // if (res.status === 403) {
    //   throw {name: 'Unauthorized', message: 'Unauthorized'};
    // }
    if (res.ok) {
      return await res.json()
    }
    console.error('Could not fetch analytics token')

  }

  static async getMediaManagerToken(workspaceId) {
    if (!workspaceId) {
      console.trace('Media manager token initialization without workspaceId')
      return
    }
    const idToken = await getIdToken()
    const uri =`https://api.form-data.com/v2/workspaces/${workspaceId}/media/token`
    const res = await fetch(uri, {
      method: 'GET',
      headers: {
        Authorization: `IDTOKEN.${idToken}`
      }
    })
    if (res.ok) {
      return await res.json()
    }
    console.error('Could not fetch media token')
  }

  static async deleteWorkspace (workspaceId) {
    const idToken = await getIdToken()
    console.log('deleting workspace', workspaceId)
    return await fetch(`${apiV2Base}/workspaces/${workspaceId}`, {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`
      }
    })
  }

  static async validateOauth (clientId, redirectUri) {
    const idToken = await getIdToken()
    console.log('validating oauth', clientId, redirectUri)
    const response = await fetch(`${apiV2Base}/oauth/validate`, {
      method: 'POST',
      body: JSON.stringify({
        client_id: clientId,
        redirect_uri: redirectUri,
      }),
      headers: {
        'Authorization': `IDTOKEN.${idToken}`,
        'Content-Type': 'application/json'
      }
    })
    return response.ok
  }

  static async generateOauthCode(client_id, workspace_id, redirect_uri, user_id, state) {
    const idToken = await getIdToken()
    const response = await fetch(`${apiV2Base}/oauth/code`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `IDTOKEN.${idToken}`,
      },
      body: JSON.stringify({
        client_id,
        workspace_id,
        redirect_uri,
        user_id,
        state
      })
    })
    if (!response.ok) {
      console.error('Could not generate oauth code', response.status, await response.text())
      return
    }
    const data = await response.json()
    return data.code
  }

  static async getSubmissionFile (workspaceId, formId, filePath, download) {
    const idToken = await getIdToken()
    console.log('getSubmissionFile', workspaceId, formId)
    const params = {
      download: !!download,
      url: filePath
    }
    const queryString = new URLSearchParams(params).toString();
    const res= await fetch(`${apiV2Base}/workspaces/${workspaceId}/forms/${formId}/submissions/files?${queryString}`, {
      method: 'GET',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`
      }
    })
    if (!res.ok) {
      const text = await res.text()
      console.error(res.status, text)
      return
    }
    const json = await res.json()
    return json.link

  }

  static async deleteSubmissions (workspaceId, formId, submissionIds) {
    const idToken = await getIdToken()
    console.log('deleting submissions', submissionIds)
    return await fetch(`${apiV2Base}/workspaces/${workspaceId}/forms/${formId}/submissions/moveToTrash`, {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({ submissionIds }),
      headers: {
        Authorization: `IDTOKEN.${idToken}`,
        'Content-Type': 'application/json'
      }
    })
  }

  static async moveSubmissionsToInbox (workspaceId, formId, submissionIds) {
    const idToken = await getIdToken()
    console.log('moving submissions to Inbox', submissionIds)
    return await fetch(`${apiV2Base}/workspaces/${workspaceId}/forms/${formId}/submissions/moveToInbox`, {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({ submissionIds }),
      headers: {
        Authorization: `IDTOKEN.${idToken}`,
        'Content-Type': 'application/json'
      }
    })
  }

  static async getMyUser () {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/users/my-user`, {
      method: 'GET',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`
      }
    })
    return (await res.json()).user
  }

  static async getAccount () {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/accounts/myAccount`, {
      method: 'GET',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`
      }
    })
    return (await res.json()).account
  }

  static async getAccountCredits (accountId) {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/accounts/${accountId}/credits`, {
      method: 'GET',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`,
        'Content-Type': 'application/json'
      }
    })
    return (await res.json()).credits
  }

  // static async getMigrationStatus () {
  //   const idToken = await getIdToken()
  //   const res = await fetch(`${apiV2Base}/accounts/myAccount/migration-status?v=2`, {
  //     method: 'GET',
  //     mode: 'cors',
  //     headers: {
  //       Authorization: `IDTOKEN.${idToken}`,
  //       'Content-Type': 'application/json'
  //     }
  //   })
  //   /** @type MigrationStatus **/
  //   const migrationStatus = (await res.json()).migrationStatus;
  //   // Set the cookie with domain=.form-data.com so it is accessible from app.form-data.com
  //   // We use it when someone logs into v1, if they were never there, we redirect them into here
  //   document.cookie = `migrationStatus={"v2User":true,"v1User":${migrationStatus.v1User}}; domain=.form-data.com; path=/; secure; samesite=None`;
  //   return migrationStatus
  // }

  // static async startMigration () {
  //   const idToken = await getIdToken()
  //   const res = await fetch(`${apiV2Base}/accounts/myAccount/start-migration`, {
  //     method: 'POST',
  //     mode: 'cors',
  //     headers: {
  //       Authorization: `IDTOKEN.${idToken}`,
  //       'Content-Type': 'application/json'
  //     }
  //   })
  //   if (res.status === 201) {
  //     return true
  //   }
  //   console.error('Could not start migration', res.status)
  //   console.error(await res.text())
  //   return false
  // }


  /**
   * Undo any pending subscription actions: cancel, pause, resume
   * @return {Promise<any>}
   */
  static async undoPendingSubscription() {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/accounts/myAccount/subscription/undo-pending`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`,
        'Content-Type': 'application/json'
      }
    })
    if (!res.ok) {
      return null
    }
    return await res.json()
  }

/**
   * Can return Checkout object - in case the client needs to show checkout
   * @param {Object} subscriptionData
   * @param {Object} subscriptionData.autoRecharge
   * @param {boolean} subscriptionData.autoRecharge.enabled
   * @param {number} subscriptionData.autoRecharge.creditsQuantity
   * @param {Array<workspaceId: string, addon:string>} subscriptionData.addons
   * @param {boolean} preview
   * @return {Promise<{action:'subscription_canceled'|'subscription_updated'|'transaction_created', subscription: Subscription}>}
   */
  static async updateSubscription(subscriptionData, preview) {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/accounts/myAccount/subscription`, {
      method: 'PATCH',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({subscriptionData, preview})
    })
    if (!res.ok) {
      return null
    }
    return await res.json()
  }

  /**
   *
   * @returns {Promise<PaddleSubscription>}
   */
  static async getSubscription() {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/accounts/myAccount/subscription`, {
      method: 'GET',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`,
        'Content-Type': 'application/json'
      }
    })
    if (!res.ok) {
      return null
    }
    return (await res.json()).subscription
  }

  static async listForms (workspaceId) {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/workspaces/${workspaceId}/forms`, {
      method: 'GET',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`
      }
    })
    return (await res.json()).forms
  }

  static async addCustomDomain (workspaceId, domain) {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/workspaces/${workspaceId}/domains`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        domain
      })
    })
    if (!res.ok) {
      // todo: handle specific errors
      return null
    }
    return await res.json()
    /**
     * {
     *   domain: string
     *   DKIMPendingHost: string
     *   DKIMPendingTextValue: string
     *   ReturnPathDomain: string
     *   ReturnPathDomainCNAMEValue: string
     *   id: number
     * }
     */
  }

  static async removeCustomDomain (workspaceId) {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/workspaces/${workspaceId}/domains`, {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`,
        'Content-Type': 'application/json'
      }
    })
    if (!res.ok) {
      // todo: handle specific errors
      return false
    }
    return true
  }

  /**
   *
   * @param {string} workspaceId
   * @param {'DKIM'|'ReturnPath'} record
   * @returns {Promise<null|{customDomain:{DKIMVerified:boolean, ReturnPathVerified:boolean}}>}
   */
  static async verifyCustomDomain (workspaceId, record) {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/workspaces/${workspaceId}/domains/verify${record}`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`,
        'Content-Type': 'application/json'
      }
    })
    if (!res.ok) {
      // todo: handle specific errors
      return null
    }
    return await res.json()
    /**
     * {
     *   DKIMVerified: boolean
     *   ReturnPathVerified: boolean
     * }
     */
  }

  static async listWorkspaces () {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/workspaces`, {
      method: 'GET',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`
      }
    })
    const json = await res.json()
    return json.teamMemberWorkspaces
  }

  static async createDefaultWorkspace () {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/workspaces/createDefault`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`
      }
    })
    const json = await res.json()
    return json.workspace
  }

  static async createWorkspace (workspaceName, workspaceColor) {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/workspaces`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        workspace: {
          name: workspaceName,
          color: workspaceColor
        }
      })
    })
    const json = await res.json()
    return json.workspace
  }

  static async getWorkspace (workspaceId) {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/workspaces/${workspaceId}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
          Authorization: `IDTOKEN.${idToken}`
        }
      })
    return (await res.json()).workspace
  }

  static async listTeamMembers(workspaceId) {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/workspaces/${workspaceId}/team`, {
      method: 'GET',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`
      }
    })
    return await res.json()
  }

  static async updateTeam(workspaceId, edited, team) {
    const res = []
    const idToken = await getIdToken()
    for (let i = 0; i < edited.length; i++) {
      if (!isEqual(edited[i], team[i])) {
        const patchRes = await fetch(`${apiV2Base}/workspaces/${workspaceId}/team/${edited[i].userId}`, {
          method: 'PATCH',
          mode: 'cors',
          headers: {
            Authorization: `IDTOKEN.${idToken}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({teamMember: edited[i]})
        })
        res.push((await patchRes.json()).teamMember)
      }
    }
    return res
  }

  static async removeFromTeam(workspaceId, userId) {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/workspaces/${workspaceId}/team/${userId}`, {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`,
      }
    })
    return res.ok;
  }

  static async acceptInvitation(workspaceId, invitationId) {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/workspaces/${workspaceId}/invitations/${invitationId}/accept`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`
      }
    })
    return res.ok
  }

  /**
   *
   * @param workspaceId
   * @param invitationId
   * @return {Promise<null|Invitation>}
   */
  static async getInvitationDetails(workspaceId, invitationId) {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/workspaces/${workspaceId}/invitations/${invitationId}`, {
      method: 'GET',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`
      }
    })
    if (!res.ok) {
      return null
    }
    return (await res.json()).invitation
  }

  static async inviteMember(workspaceId, invitation) {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/workspaces/${workspaceId}/invitations`, {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({ invitation }),
      headers: {
        Authorization: `IDTOKEN.${idToken}`,
        'Content-Type': 'application/json'
      }
    })
    return {
      ok: res.ok,
      status: res.status,
      error: res.ok ? null : (await res.json() || {}).error
    }
  }

  static async updateWorkspace (workspace) {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/workspaces/${workspace.id}`, {
      method: 'PATCH',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({workspace})
    })
    return (await res.json()).workspace
  }

  static async deleteForm (workspaceId, formId) {
    const idToken = await getIdToken()
    return await fetch(`${apiV2Base}/workspaces/${workspaceId}/forms/${formId}`, {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`
      }
    })
  }

  static async moveForm (workspaceId, destWorkspaceId, formId) {
    const idToken = await getIdToken()
    const res =  await fetch(`${apiV2Base}/workspaces/${workspaceId}/forms/${formId}/move-to-workspace`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({destWorkspaceId})
    })
    return await res.json()
  }

  static async getForm (workspaceId, formId) {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/workspaces/${workspaceId}/forms/${formId}`, {
      method: 'GET',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`
      }
    })
    const json = await res.json()
    const form = extend(true, {noBounce:{enabled:false}}, json.form)
    return form
  }

  static async getFormSchema (workspaceId, formId) {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/workspaces/${workspaceId}/forms/${formId}/schema`, {
      method: 'GET',
      mode: 'cors',
      headers: {
        Authorization: `IDTOKEN.${idToken}`
      }
    })
    const json = await res.json()
    return json.formSchema
  }

  static async blankForm () {
    const res = await fetch(`${apiV2Base}/forms/blank`, {
      method: 'GET',
      mode: 'cors'
    })
    return (await res.json()).form
  }

  static async updateForm (workspaceId, form) {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/workspaces/${workspaceId}/forms/${form.id}`, {
      method: 'PATCH',
      mode: 'cors',
      body: JSON.stringify({ form }),
      headers: {
        Authorization: `IDTOKEN.${idToken}`,
        'Content-Type': 'application/json'
      }
    })
    return (await res.json()).form
  }

  static async updateFormSchema (workspaceId, formKey, formSchema, publish) {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/workspaces/${workspaceId}/forms/by-key/${formKey}/schema`, {
      method: 'PUT',
      mode: 'cors',
      body: JSON.stringify({
        schema: formSchema,
        publish: publish
      }),
      headers: {
        Authorization: `IDTOKEN.${idToken}`,
        'Content-Type': 'application/json'
      }
    })
    if (!res.ok) {
      if (res.status === 403) {
        return { success: false, error: 'You don\'t have permissions to update the form'}
      } else if (res.status === 400) {
        return { success: false, error: 'There are errors in the form. Please fix them and try again.'}
      } else if (res.status === 404) {
        return { success: false, error: 'The form could not be found. Please copy your work and refresh the page.'}
      } else {
        return { success: false, error: 'Something went wrong. Please try again, or contact support' }
      }
    }
    const json = await res.json()
    return { success:true, ...json }
  }

  static async publishTempStudioSchema (workspaceId, formId, tempSchemaId) {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/workspaces/${workspaceId}/forms/${formId}/schema/publish-temp-studio-schema`, {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({
        tempSchemaId
      }),
      headers: {
        Authorization: `IDTOKEN.${idToken}`,
        'Content-Type': 'application/json'
      }
    })
    if (!res.ok) {
      if (res.status === 403) {
        return { success: false, error: 'You don\'t have permissions to update the form'}
      } else if (res.status === 400) {
        return { success: false, error: 'There are errors in the form. Please fix them and try again.'}
      } else if (res.status === 404) {
        return { success: false, error: 'The form could not be found. Please copy your work and refresh the page.'}
      } else {
        return { success: false, error: 'Something went wrong. Please try again, or contact support' }
      }
    }
    const json = await res.json()
    return { success:true, ...json }
  }

  static async createForm (workspaceId, form = {}) {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/workspaces/${workspaceId}/forms`, {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({ form }),
      headers: {
        Authorization: `IDTOKEN.${idToken}`,
        'Content-Type': 'application/json'
      }
    })
    return (await res.json()).form
  }

  static async createFreeAccount () {
    const idToken = await getIdToken()
    const res = await fetch(`${apiV2Base}/accounts`, {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({account:{}}),
      headers: {
        Authorization: `IDTOKEN.${idToken}`,
        'Content-Type': 'application/json'
      }
    })
    return (await res.json()).account
  }
}

export default Api


/**
 * @typedef PaddleSubscription
 * @property {string} id - the subscription id
 * @property {'active'|'canceled'|'past_due'|'paused'|'trialing'} status
 * @property {string} customer_id
 * @property {string} address_id
 * @property {string|null} business_id
 * @property {string} currency_code - three-letter ISO 4217 currency code. E.g. 'USD'
 * @property {string} created_at - RFC 3339 datetime string of when this entity was created. Set automatically by Paddle.
 * @property {string} updated_at - RFC 3339 datetime string of when this entity was updated. Set automatically by Paddle.
 * @property {string} started_at - RFC 3339 datetime string of when this subscription started. This may be different from first_billed_at if the subscription started in trial.
 * @property {string} first_billed_at - RFC 3339 datetime string of when this subscription was first billed. This may be different from started_at if the subscription started in trial.
 * @property {string} next_billed_at - RFC 3339 datetime string of when this subscription is next scheduled to be billed.
 * @property {string} paused_at - RFC 3339 datetime string of when this subscription was paused. Set automatically by Paddle when the pause subscription operation is used. null if not paused.
 * @property {string} canceled_at - RFC 3339 datetime string of when this subscription was canceled. Set automatically by Paddle when the cancel subscription operation is used. null if not canceled.
 * @property {Object<{id:string, starts_at:string, ends_at:string}>} discount
 * @property {'manual'|'automatic'} collection_mode
 * @property {Object} billing_details
 * @property {boolean} billing_details.enable_checkout - Whether the related transaction may be paid using a Paddle Checkout.
 * @property {string} billing_details.purchase_order_number - Customer purchase order number. Appears on invoice documents.
 * @property {string|null} billing_details.additional_information - Notes or other information to include on this invoice. Appears on invoice documents.
 * @property {Object<{interval:'day'|'week'|'month'|'year'}, frequency:number>} billing_details.payment_terms - How long a customer has to pay this invoice once issued.
 * @property {Object|null} current_billing_period
 * @property {string} current_billing_period.starts_at - RFC 3339 datetime string of when this period starts.
 * @property {string} current_billing_period.ends_at - RFC 3339 datetime string of when this period ends.
 * @property {Object<{interval:'day'|'week'|'month'|'year'}, frequency:number>} billing_cycle - How often this subscription renews. Set automatically by Paddle based on the prices on this subscription.
 * @property {Object|null} scheduled_change - Change that's scheduled to be applied to a subscription. Use the pause subscription, cancel subscription, and resume subscription operations to create scheduled changes. null if no scheduled changes.
 * @property {'cancel'|'resume'|'pause'} scheduled_change.action
 * @property {string} scheduled_change.effective_at - RFC 3339 datetime string of when this scheduled change takes effect.
 * @property {string} scheduled_change.resume_at - RFC 3339 datetime string of when a paused subscription should resume. Only used for pause scheduled changes.
 * @property {Object} management_urls - Public URLs that customers can use to make changes to this subscription. For security, the token appended to each link is temporary. You shouldn't store these links.
 * @property {string|null} management_urls.update_payment_method - Public URL that lets customers update the payment method for this subscription. Creates or gets a transaction that can be used to update a payment method, then passes it to your default checkout page.
 * @property {string|null} management_urls.cancel - Public URL that lets customers cancel this subscription. Takes customers to a Paddle page that lets them cancel their subscription.
 * @property {Array<Object>} items
 * @property {'active'|'inactive'|'trialing'} items.status
 * @property {number} items.quantity
 * @property {boolean} items.recurring
 * @property {string} items.created_at
 * @property {string} items.updated_at
 * @property {string|null} items.previously_billed_at
 * @property {string|null} items.next_billed_at
 * @property {Object<{starts_at:string, ends_at:string}>} items.trial_dates
 * @property {Object} items.price
 * @property {string} items.price.id - Unique Paddle ID for this price, prefixed with pri_.
 * @property {string} items.price.description -
 * @property {string} items.price.product_id - Paddle ID for the product that this price is for, prefixed with pro_.
 * @property {Object<{interval:'day'|'week'|'month'|'year', frequency:number}>|null} items.price.billing_cycle -How often this price should be charged. null if price is non-recurring (one-time).
 * @property {Object<{interval:'day'|'week'|'month'|'year', frequency:number}>|null} items.price.trial_period - Trial period for the product related to this price. The billing cycle begins once the trial period is over. null for no trial period. Requires billing_cycle.
 * @property {'account_setting'|'external'|'internal'} items.price.tax_mode - How tax is calculated for this price.
 * @property {Object} items.price.unit_price - Unit price for this price. This is the cost for one unit.
 * @property {string} items.price.unit_price.amount - Amount in the lowest denomination for the currency, e.g. 10 USD = 1000 (cents).
 * @property {string} items.price.unit_price.currency_code - Supported three-letter ISO 4217 currency code.
 * @property {Object|null} custom_data
 * @property {Object<{external_id:string, imported_from:string}>|null} import_meta
 * @property {Object|null} next_transaction
 * @example {
 "id": "sub_01h84qezffcfrjx275ve304rt0",
 "status": "active",
 "customer_id": "ctm_01h82et3vctdaapjzerb3xrkex",
 "address_id": "add_01h84qdjewtveve149393qfqcz",
 "business_id": null,
 "currency_code": "USD",
 "created_at": "2023-08-18T16:25:40.591Z",
 "updated_at": "2023-08-18T16:25:40.591Z",
 "started_at": "2023-08-18T16:25:38.870962Z",
 "first_billed_at": "2023-08-18T16:25:38.870962Z",
 "next_billed_at": "2023-09-18T16:25:38.870962Z",
 "paused_at": null,
 "canceled_at": null,
 "collection_mode": "automatic",
 "billing_details": null,
 "current_billing_period": {
 "starts_at": "2023-08-18T16:25:38.870962Z",
 "ends_at": "2023-09-18T16:25:38.870962Z"
 },
 "import_meta": null,
 "billing_cycle": {
 "frequency": 1,
 "interval": "month"
 },
 "scheduled_change": null,
 "items": [
 {
 "status": "active",
 "quantity": 10,
 "recurring": true,
 "created_at": "2023-08-18T16:25:40.591Z",
 "updated_at": "2023-08-18T16:25:40.591Z",
 "previously_billed_at": "2023-08-18T16:25:38.870962Z",
 "next_billed_at": "2023-09-18T16:25:38.870962Z",
 "trial_dates": null,
 "price": {
 "id": "pri_01gsz8x8sawmvhz1pv30nge1ke",
 "product_id": "pro_01gsz4t5hdjse780zja8vvr7jg",
 "description": "Monthly (per seat)",
 "tax_mode": "account_setting",
 "billing_cycle": {
 "frequency": 1,
 "interval": "month"
 },
 "trial_period": null,
 "unit_price": {
 "amount": "3570",
 "currency_code": "USD"
 }
 }
 },
 {
 "status": "active",
 "quantity": 1,
 "recurring": true,
 "created_at": "2023-08-18T16:25:40.591Z",
 "updated_at": "2023-08-18T16:25:40.591Z",
 "previously_billed_at": "2023-08-18T16:25:38.870962Z",
 "next_billed_at": "2023-09-18T16:25:38.870962Z",
 "trial_dates": null,
 "price": {
 "id": "pri_01gsz95g2zrkagg294kpstx54r",
 "product_id": "pro_01gsz92krfzy3hcx5h5rtgnfwz",
 "description": "Monthly (recurring addon)",
 "tax_mode": "account_setting",
 "billing_cycle": {
 "frequency": 1,
 "interval": "month"
 },
 "trial_period": null,
 "unit_price": {
 "amount": "29750",
 "currency_code": "USD"
 }
 }
 }
 ],
 "custom_data": null,
 "management_urls": {
 "update_payment_method": "https://buyer-portal.paddle.com/subscriptions/sub_01h84qezffcfrjx275ve304rt0/update-payment-method",
 "cancel": "https://buyer-portal.paddle.com/subscriptions/sub_01h84qezffcfrjx275ve304rt0/cancel"
 },
 "discount": null
 }

 */
